import React, { Component } from 'react'
import commonUI from '../../../js/commonUI'
import DarkThemeNav from '../common/dark-theme-nav';

class Modals extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedModalStyle: '',
      selectedModalSize: '',
      modalSizeTitle: '',
    }

    this.toggleModalStyle = this.toggleModalStyle.bind(this);
    this.toggleModalSize = this.toggleModalSize.bind(this);
    this.registerModalListeners = this.registerModalListeners.bind(this);
  }

  componentDidMount() {
    commonUI.initializeModal({
      selector: '.complex-example-modal',
      clickElementSelector: '.complex-example-button',
    });
    commonUI.initializeModal({
      selector: '.events-example-modal',
      clickElementSelector: '.events-example-button',
    });
    commonUI.initializeModal({
      selector: '.size-example-modal',
      clickElementSelector: '.toggle-modal-size',
    });
    commonUI.initializeModal({
      selector: '.style-example-modal',
      clickElementSelector: '.toggle-modal-style',
    });

    this.registerModalListeners();
  }

  registerModalListeners() {
    const modalStyleBtns = document.querySelectorAll('.toggle-modal-style');
    const modalSizeBtns = document.querySelectorAll('.toggle-modal-size');
    modalStyleBtns.forEach((btn) => btn.addEventListener('click', () => this.toggleModalStyle(btn.value)));
    modalSizeBtns.forEach((btn) => btn.addEventListener('click', () => this.toggleModalSize(btn.value)));
  }

  toggleModalStyle(style) {
    this.setState({
      selectedModalStyle: `${ style } modal--is-open`,
    });
  }

  toggleModalSize(size) {
    this.setState({
      selectedModalSize: `modal--is-${ size } modal--is-open`,
      modalSizeTitle: size.slice(0, 1).toUpperCase() + size.slice(1),
    });
  }

  render() {
    return (
    <section>
      <a className="anchor" id="modals"></a>
      <h2>Modals</h2>
      <p>Overlays are typically intended to get users to view content, complete a form, or make a decision.<br/><br/>
      Other good reasons to use modals:<br/>
      The user is about to take an action that has serious consequences and is difficult to reverse.<br/>
      It’s essential to collect a small amount of information before letting users proceed to the next step in a process.<br/>
      The content in the overlay is urgent, and users are more likely to notice it in an overlay.</p>

      <DarkThemeNav anchor="modal" />
      <div className="modal js-modal">
        <div className="modal__inner">
          <header className="modal__header" aria-labelledby="modal__title">
            <h1 className="modal__title">Modal Heading</h1>
            <button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
              <i className="fas fa-times icon--medium"></i>
            </button>
          </header>
          <div className="modal__contents" role="dialog" aria-hidden="false" aria-describedby="modal__description">
            <p className="modal__description">This is a description of what this modal is for</p>
          </div>
          <footer className="modal__footer">
            <button type="button" className="modal__cancel btn btn--secondary btn--outline js-modal-close">Cancel</button>
              <button type="button" className="modal__confirm btn js-modal-positive">Confirm</button>
          </footer>
        </div>
      </div>

      <p>By default, the library will look for the class <code className="inline">.js-modal</code> for the content and <code className="inline">.js-modal__button</code> to attach the open modal event to.</p>
      <div className="display-inline-block">
        <button className="btn js-modal__button">Simplest Example</button>
      </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="modal js-modal">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Modal heading</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
      <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<button class="btn js-modal__button">Simplest Example</button>`}</code></pre>

    <pre className="language-javascript"><code className="language-javascript">{`// Using default classes shown in snippet.
commonUI.initializeModal();`}</code></pre>

    <br/>
    <p>There are five options for sizing at non-mobile sizes, these are applied by the classes:
      <br />
      <code className="inline">modal--is-fullscreen | modal--is-large | modal--is-medium | modal--is-small | modal--is-xsmall </code>
      <br />
      If none of the above classes are applied, the default modal size is Medium
    </p>

    <div className="display-inline-block">
      <button className="btn toggle-modal-size push-quarter--ends" value="fullscreen">Fullscreen Example</button>&nbsp;
      <button className="btn toggle-modal-size push-quarter--ends" value="large">Large Example</button>&nbsp;
      <button className="btn toggle-modal-size push-quarter--ends" value="medium">Medium Example</button>&nbsp;
      <button className="btn toggle-modal-size push-quarter--ends" value="small">Small Example</button>&nbsp;
      <button className="btn toggle-modal-size push-quarter--ends" value="xsmall">XSmall Example</button>
    </div>

    <div className={`modal ${ this.state.selectedModalSize } size-example-modal`}>
      <div className="modal__inner">
        <header className="modal__header" aria-labelledby="modal__title">
          <h1 className="modal__title">{ this.state.modalSizeTitle } Modal Example</h1>
          <button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
            <i className="fas fa-times icon--medium"></i>
          </button>
        </header>
        <div className="modal__contents" role="dialog" aria-hidden="false" aria-describedby="modal__description">
          <p className="modal__description">
            This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.
            This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.
          </p>
        </div>
        <footer className="modal__footer">
          <button type="button" className="modal__cancel btn btn--secondary btn--outline js-modal-close">Cancel</button>
          <button type="button" className="modal__confirm btn js-modal-positive">Confirm</button>
        </footer>
      </div>
    </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="modal fullscreen-example-modal modal--is-fullscreen">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Fullscreen</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal large-example-modal modal--is-large">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Large</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal medium-example-modal modal--is-medium">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Medium</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal small-example-modal modal--is-small">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Small</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal xsmall-example-modal modal--is-xsmall">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Xsmall</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<button class="btn fullscreen-example-button">Fullscreen Example</button>
<button class="btn large-example-button">Large Example</button>
<button class="btn medium-example-button">Medium Example</button>
<button class="btn small-example-button">Small Example</button>
<button class="btn xsmall-example-button">Xsmall Example</button>`}</code></pre>
    <pre className="language-javascript"><code className="language-javascript">{`// With multiple modals on the page,
// each needs unique content and areas for the click handlers.
commonUI.initializeModal(
  {
    selector: '.fullscreen-example-modal',
    clickElementSelector: '.fullscreen-example-button'
  }
);
commonUI.initializeModal(
  {
    selector: '.large-example-modal',
    clickElementSelector: '.large-example-button'
  }
);
commonUI.initializeModal(
  {
    selector: '.medium-example-modal',
    clickElementSelector: '.medium-example-button'
  }
);
commonUI.initializeModal(
  {
    selector: '.small-example-modal',
    clickElementSelector: '.small-example-button'
  }
);
commonUI.initializeModal(
  {
    selector: '.xsmall-example-modal',
    clickElementSelector: '.xsmall-example-button'
  }
);`}</code></pre>

    <div className="modal complex-example-modal modal--is-large">
      <div className="modal__inner">
        <header className="modal__header" aria-labelledby="modal__title">
          <h1 className="modal__title">Example Search</h1>
          <button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
            <i className="icon-cme-card-close icon--medium"></i>
          </button>
        </header>
        <div className="modal__contents" role="dialog" aria-hidden="false" aria-describedby="modal__description">
          <p className="modal__description">Enter your search term in the field to fetch results</p>
          <ul className="form-fields grid">
            <li className="grid__col-12 hard">
              <div className="icon__wrapper icon__wrapper--left"><i className="fa fa-search"></i></div>
              <label>Search</label><input type="text" className="text-input"></input>
            </li>
          </ul>
          <br/>
          <table className="table table--cells table--comfy table--hover table--striped table--dark">
            <thead>
              <tr>
                <th>Lorem</th>
                <th>Ipsum</th>
                <th>Dolor</th>
                <th>Sit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Sit</td>
                <td>Dolor</td>
                <td className="text--center">03.788</td>
                <td>Lorem</td>
              </tr>
              <tr>
                <td>Sit</td>
                <td>Dolor</td>
                <td className="text--center">32.210</td>
                <td>Lorem</td>
              </tr>
              <tr>
                <td>Sit</td>
                <td>Dolor</td>
                <td className="text--center">47.797</td>
                <td>Lorem</td>
              </tr>
              <tr>
                <td>Sit</td>
                <td>Dolor</td>
                <td className="text--center">09.640</td>
                <td>Lorem</td>
              </tr>
              <tr>
                <td>Sit</td>
                <td>Dolor</td>
                <td className="text--center">12.117</td>
                <td>Lorem</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer className="modal__footer">
          <button type="button" className="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
          <button type="button" className="modal__confirm btn js-modal-positive">OK</button>
        </footer>
      </div>
    </div>

      <br/>
      <p>A more realistic example with content</p>

      <button className="btn complex-example-button">Content example</button>
      <br/><br/><br/>

      <h3>Modal Header Color Styles</h3>

      <p>There are three color options for modal headers, these are applied by the classes:
        <br />
        <code className="inline">modal | modal modal--navy-header | modal modal--grey-header </code>
      </p>

      <div className="display-inline-block">
        <button className="btn toggle-modal-style push-quarter--ends" value="">Default Header</button>&nbsp;
        <button className="btn toggle-modal-style push-quarter--ends" value="modal--navy-header">Navy Header</button>&nbsp;
        <button className="btn toggle-modal-style push-quarter--ends" value="modal--grey-header">Grey Header</button>
      </div>

      <br/><br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="modal modal--navy-header">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Fullscreen</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal modal--grey-header">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Large</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>`}</code></pre>

      <h3>Modal Full Color Styles</h3>

      <p>There are three color options for modal full colour styles, these are applied by the classes:
        <br />
        <code className="inline">modal | modal modal--navy | modal modal--navy-dark | modal modal--grey </code>
      </p>

      <div className="display-inline-block">
        <button className="btn toggle-modal-style push-quarter--ends" value="">Default Style</button>&nbsp;
        <button className="btn toggle-modal-style push-quarter--ends" value="modal--navy">Navy Style</button>&nbsp;
        <button className="btn toggle-modal-style push-quarter--ends" value="modal--navy-dark">Dark Navy Style</button>&nbsp;
        <button className="btn toggle-modal-style push-quarter--ends" value="modal--grey">Grey Style</button>
      </div>

      <div className={`modal ${ this.state.selectedModalStyle } style-example-modal`}>
        <div className="modal__inner">
          <header className="modal__header" aria-labelledby="modal__title">
            <h1 className="modal__title">Modal Header Style</h1>
            <button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
              <i className="fas fa-times icon--medium"></i>
            </button>
          </header>
          <div className="modal__contents" role="dialog" aria-hidden="false" aria-describedby="modal__description">
            <p className="modal__description">
              This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.
              This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.
            </p>
          </div>
          <footer className="modal__footer">
            <button type="button" className="modal__cancel btn btn--secondary btn--outline js-modal-close">Cancel</button>
            <button type="button" className="modal__confirm btn js-modal-positive">Confirm</button>
          </footer>
        </div>
      </div>

      <br/><br/>
      <br/><br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="modal modal--navy">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Fullscreen</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal modal--navy-dark">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Large</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>

<div class="modal modal--grey">
  <div class="modal__inner">
    <header class="modal__header" aria-labelledby="modal__title">
      <h1 class="modal__title">Large</h1>
      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">
        <i class="icon-cme-card-close icon--medium"></i>
      </button>
    </header>
    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
      <p class="modal__description">This is a description of what this modal is for</p>
    </div>
    <footer class="modal__footer">
        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>
    </footer>
  </div>
</div>`}</code></pre>

      <h3>Caution!</h3>
      <p>On mobile: a new page should be displayed instead of using an overlay for mobile. Refer to <a href="http://bradfrost.com/blog/post/conditional-lightbox/">Brad Frosts Conditional Lightbox</a> for additional info.<br/>
      Scrolling and anchor links make sense on very long web pages. But if you find yourself adding multiple navigation mechanisms within an overlay, it’s time to stop and reevaluate your approach.<br/>
      If someone might need to share the content, an overlay is not a good option - a new page should be used instead. </p>

      <h3>Best Practices</h3>
      <p>Provide a visible ‘close’ command to allow users to return to the underlying page.<br/>
      Overlays that ask users to provide input, even if it is just a single field, need an explicit ‘Cancel’ option.<br/>
      To help users recover from accidentally closing the overlay, any field inputs should be saved and the overlay should be easy to reactivate.<br/>
      To help users avoid dismissing a lightbox without understanding the consequences of their actions, use an explicit  button label that states exactly what will happen when the user clicks it, as LinkedIn does with their ‘Yes, Remove them’ confirmation button on the lightbox to confirm deleting a contact.</p>

      <h3>Accessibility Tips</h3>
      <p>The aria and other associated attributes help screenreader users to navigate the modal</p>
      <code className="inline">role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description"</code>
      <br/><br/>
      <p>The escape key is bound to close the modal and the tab order is automatically set inside the modal when opened.<br/>
      The first element of the modal should be a <code className="inline">&lt;h1&gt;</code> to allow the screenreaders to construct the document correctly.</p>

      <br/>
      <br/>
      <h3>Programatic control</h3>
      <p>The modal exposes open and close methods.</p>
      <code className="inline">{`var modal = commonUI.initializeModal({selector:'.example-modal'});`}</code>
      <br/><br/>
      <table className="table table--fixed table--cells table--comfy">
        <thead>
          <tr>
            <th>Method</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>modal.open()</td>
          <td>Opens the modal</td>
        </tr>
        <tr>
          <td>modal.close()</td>
          <td>Closes the modal, does not fire positive/negative events</td>
        </tr>
        <tr>
          <td>modal.positive()</td>
          <td>Closes the modal, fires positive event</td>
        </tr>
        <tr>
          <td>modal.negative()</td>
          <td>Closes the modal, fires negative event</td>
        </tr>
        </tbody>
      </table>

      <br/>
      <br/>
      <h3>Events</h3>
      <p>The modal exposes a few events for hooking into modal functionality.</p>

      <table className="table table--fixed table--cells table--comfy">
        <thead>
          <tr>
            <th>Event Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>show.commonui.modal</td>
          <td>This event fires immediately when the open instance method is called.</td>
        </tr>
        <tr>
          <td>hide.commonui.modal</td>
          <td>This event is fired immediately when the close instance method has been called.</td>
        </tr>
        <tr>
          <td>negative.commonui.modal</td>
          <td>This event is fired when the user clicks a .js-modal-close element</td>
        </tr>
        <tr>
          <td>positive.commonui.modal</td>
          <td>This event is fired when the user clicks a .js-modal-positive element</td>
        </tr>
        </tbody>
      </table>

      <p>Open the browser console to see the events firing with the below example</p>
      <p>All modal events are fired at the modal instance itself (i.e. at the &lt;div class="events-example-modal"&gt;).</p>

      <div className="modal events-example-modal modal--is-large">
        <div className="modal__inner">
          <header className="modal__header" aria-labelledby="modal__title">
            <h1 className="modal__title">Hello</h1>
            <button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
              <i className="icon-cme-card-close icon--medium"></i>
            </button>
          </header>
          <div className="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
            <p className="modal__description">This is a description of what this modal is for</p>
          </div>
          <footer className="modal__footer">
            <button type="button" className="modal__cancel btn btn--secondary js-modal-close">Cancel</button>
            <button type="button" className="modal__confirm btn js-modal-positive">OK</button>
          </footer>
        </div>
      </div>
      <button className="btn events-example-button">Events example</button>
      <br/><br/>
      <pre><code className="language-js">{`commonUI.initializeModal(
  {
    selector: '.events-example-modal',
    clickElementSelector: '.events-example-button'
  }
);

var eventsExampleModal = document.getElementsByClassName('events-example-modal')[0];

eventsExampleModal.addEventListener('show.commonui.modal', function(){
    console.log('modal show')
});
eventsExampleModal.addEventListener('hide.commonui.modal', function(){
    console.log('modal hide')
});
eventsExampleModal.addEventListener('positive.commonui.modal', function(){
    console.log('modal positive')
});
eventsExampleModal.addEventListener('negative.commonui.modal', function(){
    console.log('modal negative')
});`}</code></pre>
      <br/>
      <hr/>
    </section>
  )
}
}

export default Modals



// WEBPACK FOOTER //
// ./styleguide/components/sections/Modals.js